var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"margin-left":"-8px"},attrs:{"fab":"","small":"","depressed":"","color":_vm.value ? 'primary' : 'secondary'},on:{"click":function($event){return _vm.toggle()}}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.icon)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }